import ShapeBase from './ShapeBase';
import { fabric } from 'fabric';
import type { ToolList } from '../fabric/ObjectBehaviors';
import type Shape from '../objects/Shape';
import { type SVGCommand } from '../types';
import paper from 'paper';

class ShapeCustomPath extends ShapeBase {
  booleanOperationCompatible = true;
  path: SVGCommand[];
  pathOffset = { x: 0, y: 0 };

  constructor(fabricObject: Shape) {
    super(fabricObject);

    fabricObject.set({
      width: fabricObject.width,
      height: fabricObject.height,
      left: fabricObject.left,
      top: fabricObject.top,
    });

    this.path = fabricObject.shapePath
      ? fabric.util.makePathSimpler(
          fabric.util.parsePath(fabricObject.shapePath)
        )
      : [];
  }

  hasFixedDimensions() {
    return false;
  }

  // Remove shape type from object tools
  tools(topLevel?: boolean): ToolList {
    return super.tools(topLevel).slice(1);
  }

  paperPath(): paper.PathItem {
    return new paper.CompoundPath(this.fabricObject.shapePath as string);
  }

  render(ctx: CanvasRenderingContext2D) {
    this._setBorderDash(ctx);
    fabric.Path.prototype._renderPathCommands.call(this, ctx);
    this.fabricObject._renderPaintInOrder(ctx);
  }
}

export default ShapeCustomPath;
